/**
 * Variáveis de contexto disponíveis no fluxo do ChatBot (compatível com Xpro legado).
 * Usar na resposta com $nome (ex.: $nomecliente). São substituídas pelo valor no momento do envio.
 *
 * Também alimentam o select de Condições — manter alinhado às chaves escalares do contexto URA
 * (ver chatbotReservedContextKeys). Objetos internos (viagem, assentos, cliente…) ficam de fora.
 */
export const VARIAVEIS_CONTEXTO = [
  // Fluxo / conversa
  { name: "$resposta", label: "Resposta acumulada", group: "fluxo" },
  { name: "$mensagem", label: "Última mensagem do usuário", group: "fluxo" },
  { name: "$respostaagente", label: "Resposta do agente de IA (neste passo)", group: "fluxo" },
  { name: "$datadigitada", label: "Data digitada (pelo usuário no fluxo)", group: "fluxo" },
  { name: "$datadevolta", label: "Data de volta", group: "fluxo" },
  { name: "$horadigitada", label: "Hora digitada", group: "fluxo" },
  { name: "$origem", label: "Origem (nome da cidade)", group: "fluxo" },
  { name: "$destino", label: "Destino (nome da cidade)", group: "fluxo" },
  { name: "$orgaoconcedente", label: "Órgão concedente do trecho (Totalbus)", group: "fluxo" },
  { name: "$tiporota", label: "Tipo de rota / órgão concedente retornado", group: "fluxo" },
  { name: "$erroconsultaorgaoconcedente", label: "Erro na consulta de órgão concedente", group: "fluxo" },
  { name: "$dataorgaoconcedente", label: "Data usada na consulta de órgão concedente", group: "fluxo" },
  {
    name: "$formatadonomecidadeorigem",
    label: "Nome formatado da cidade de origem",
    group: "fluxo",
  },
  {
    name: "$formatadonomecidadedestino",
    label: "Nome formatado da cidade de destino",
    group: "fluxo",
  },
  {
    name: "$voltaformatadonomecidadeorigem",
    label: "Nome formatado da origem na volta (= destino da ida)",
    group: "fluxo",
  },
  {
    name: "$voltaformatadonomecidadedestino",
    label: "Nome formatado do destino na volta (= origem da ida)",
    group: "fluxo",
  },
  { name: "$horapartida", label: "Horário de partida (viagem selecionada)", group: "fluxo" },
  { name: "$horachegada", label: "Horário de chegada (viagem selecionada)", group: "fluxo" },
  { name: "$valor", label: "Valor da viagem selecionada", group: "fluxo" },
  { name: "$classesuburbano", label: "Classe suburbano (true/false)", group: "fluxo" },
  { name: "$periodoviagem", label: "Período da viagem (ida)", group: "fluxo" },
  { name: "$periodoviagemvolta", label: "Período da viagem (volta)", group: "fluxo" },
  { name: "$voltahorapartida", label: "Horário de partida da volta", group: "fluxo" },
  { name: "$voltahorachegada", label: "Horário de chegada da volta", group: "fluxo" },
  { name: "$voltavalor", label: "Valor da viagem de volta", group: "fluxo" },
  { name: "$poltrona1", label: "Poltrona do 1º passageiro (também $poltrona2…)", group: "fluxo" },
  { name: "$voltapoltrona1", label: "Poltrona de volta do 1º passageiro", group: "fluxo" },
  { name: "$nomepassageiro", label: "Nome do passageiro", group: "fluxo" },
  { name: "$documentopassageiro", label: "Documento do passageiro", group: "fluxo" },
  { name: "$passageironome", label: "Nome do passageiro (alias legado)", group: "fluxo" },
  { name: "$passageirodocumento", label: "Documento do passageiro (alias legado)", group: "fluxo" },
  { name: "$emailpassageiro", label: "E-mail do passageiro", group: "fluxo" },
  { name: "$cpfpagador", label: "CPF do pagador", group: "fluxo" },
  { name: "$dadosdospassageiros", label: "Resumo textual dos passageiros", group: "fluxo" },
  { name: "$dadospassageiros", label: "Resumo dos passageiros (alias)", group: "fluxo" },
  { name: "$assentoselecionado", label: "Assento(s) selecionado(s)", group: "fluxo" },
  { name: "$assentoselecionadovolta", label: "Assento(s) selecionado(s) na volta", group: "fluxo" },
  { name: "$assentosdisponiveis", label: "Assentos disponíveis (ida)", group: "fluxo" },
  { name: "$assentosdisponiveisvolta", label: "Assentos disponíveis (volta)", group: "fluxo" },
  { name: "$errosalvarassento", label: "Erro ao salvar assento", group: "fluxo" },
  { name: "$voltaerrosalvarassento", label: "Erro ao salvar assento da volta", group: "fluxo" },
  { name: "$opcaoreserva", label: "Opção de reserva (nº do horário)", group: "fluxo" },
  { name: "$opcaoreservavolta", label: "Opção de reserva da volta", group: "fluxo" },
  { name: "$valorpagamento", label: "Valor total do pagamento", group: "fluxo" },
  { name: "$valor_unitario", label: "Valor unitário da passagem", group: "fluxo" },
  { name: "$valorsemacrescimo", label: "Valor sem acréscimo", group: "fluxo" },
  { name: "$valoracrescimo", label: "Valor do acréscimo", group: "fluxo" },
  { name: "$valor_taxa", label: "Valor da taxa", group: "fluxo" },
  { name: "$valorcomacrescimo", label: "Valor com acréscimo", group: "fluxo" },
  { name: "$quantidade_passageiros", label: "Quantidade de passageiros", group: "fluxo" },
  { name: "$retornoviagem", label: "Retorno viagem", group: "fluxo" },
  { name: "$resultadoconsultahorarios", label: "Resultado consulta horários", group: "fluxo" },
  { name: "$erroconsultahorarios", label: "Erro consulta horários", group: "fluxo" },
  { name: "$resultadoconsultaopcaoselecionada", label: "Resultado opção selecionada", group: "fluxo" },
  { name: "$resultadoconsultaassentos", label: "Resultado consulta assentos", group: "fluxo" },
  { name: "$erroconsultaassentos", label: "Erro consulta assentos", group: "fluxo" },
  { name: "$resultadoconsultaapi", label: "Resultado da consulta à API", group: "fluxo" },
  { name: "$origemencomenda", label: "Origem da encomenda", group: "fluxo" },
  { name: "$destinoencomenda", label: "Destino da encomenda", group: "fluxo" },
  { name: "$valornf", label: "Valor da NF (encomenda)", group: "fluxo" },
  { name: "$peso", label: "Peso (encomenda)", group: "fluxo" },
  { name: "$largura", label: "Largura (encomenda)", group: "fluxo" },
  { name: "$altura", label: "Altura (encomenda)", group: "fluxo" },
  { name: "$comprimento", label: "Comprimento (encomenda)", group: "fluxo" },

  // Cliente
  { name: "$nomecliente", label: "Nome do cliente", group: "cliente" },
  { name: "$nomeclientevalido", label: "Nome do cliente (validado)", group: "cliente" },
  { name: "$cadastroencontrado", label: "Cadastro encontrado (1 ou 0)", group: "cliente" },
  { name: "$lgpd", label: "LGPD aceita no cadastro (1 ou 0)", group: "cliente" },
  { name: "$cpfcliente", label: "CPF do cliente", group: "cliente" },
  { name: "$cnpjcliente", label: "CNPJ do cliente", group: "cliente" },
  { name: "$emailcliente", label: "E-mail do cliente", group: "cliente" },
  { name: "$telefonecliente", label: "Telefone do cliente", group: "cliente" },
  { name: "$celularcliente", label: "Celular do cliente", group: "cliente" },
  { name: "$tagscliente", label: "Tags do cliente", group: "cliente" },
  { name: "$tagcliente", label: "Tag do cliente", group: "cliente" },
  {
    name: "$etapaconsciencia",
    label: "Nível de consciência (nome da etapa cadastrada, ou “não definido”)",
    group: "cliente",
  },
  { name: "$endereco", label: "Endereço do cliente", group: "cliente" },
  { name: "$bairro", label: "Bairro do cliente", group: "cliente" },
  { name: "$cidade", label: "Cidade do cliente", group: "cliente" },
  { name: "$uf", label: "UF do cliente", group: "cliente" },
  { name: "$datanascimentocliente", label: "Data de nascimento do cliente", group: "cliente" },
  { name: "$campanha", label: "Campanha", group: "cliente" },
  { name: "$produto", label: "Produto", group: "cliente" },
  { name: "$filtroprodutos", label: "Filtro de produtos", group: "cliente" },

  // Sistema
  { name: "$protocolo", label: "Protocolo / ID da solicitação", group: "sistema" },
  { name: "$operador", label: "Nome do operador", group: "sistema" },
  { name: "$pontuacao", label: "Pontuação", group: "sistema" },
  { name: "$tags", label: "Tags", group: "sistema" },
  { name: "$id_transacao", label: "ID da transação", group: "sistema" },
  { name: "$qrcodepixreserva", label: "QR Code PIX reserva", group: "sistema" },
  { name: "$urlpagamento", label: "URL de pagamento", group: "sistema" },
  { name: "$planilha", label: "Planilha (resultado)", group: "sistema" },
  { name: "$planilha_count", label: "Quantidade de linhas da planilha", group: "sistema" },

  // Data e hora
  { name: "$datacompleta", label: "Data completa", group: "data" },
  { name: "$data", label: "Data", group: "data" },
  { name: "$dia", label: "Dia", group: "data" },
  { name: "$mes", label: "Mês", group: "data" },
  { name: "$ano", label: "Ano", group: "data" },
  { name: "$horacompleta", label: "Hora completa", group: "data" },
  { name: "$hora", label: "Hora", group: "data" },
  { name: "$minuto", label: "Minuto", group: "data" },
  { name: "$segundo", label: "Segundo", group: "data" },
  { name: "$diasemana", label: "Dia da semana", group: "data" },
  { name: "$data_hoje", label: "Data de hoje (DD/MM/AAAA)", group: "data" },
  { name: "$data_hoje_us", label: "Data de hoje (AAAA-MM-DD)", group: "data" },
];

const GROUPS = {
  fluxo: "Fluxo / conversa",
  cliente: "Cliente",
  sistema: "Sistema",
  data: "Data e hora",
  outros: "Outras",
};

/** Ordem estável para Autocomplete groupBy (grupos contíguos). */
const GROUP_ORDER = ["fluxo", "cliente", "sistema", "data", "outros"];

export function getVariablesByGroup() {
  const byGroup = {};
  VARIAVEIS_CONTEXTO.forEach((v) => {
    const g = v.group || "outros";
    if (!byGroup[g]) byGroup[g] = [];
    byGroup[g].push(v);
  });
  return { byGroup, groupLabels: GROUPS };
}

export function contextKeyFromVariableName(name) {
  return String(name || "")
    .replace(/^\$/, "")
    .trim()
    .toLowerCase();
}

function groupSortIndex(group) {
  const idx = GROUP_ORDER.indexOf(group || "outros");
  return idx === -1 ? GROUP_ORDER.length : idx;
}

export function getConditionContextVariables() {
  return VARIAVEIS_CONTEXTO.map((v) => ({
    key: contextKeyFromVariableName(v.name),
    label: v.label,
    group: v.group || "outros",
    messageVar: v.name.startsWith("$")
      ? `$${contextKeyFromVariableName(v.name)}`
      : v.name,
  })).sort(
    (a, b) =>
      groupSortIndex(a.group) - groupSortIndex(b.group) ||
      a.label.localeCompare(b.label, "pt-BR")
  );
}

/** Variáveis de cadastro do cliente para personalizar disparos. */
export function getCampaignContextVariables() {
  return VARIAVEIS_CONTEXTO.filter((v) => v.group === "cliente");
}
